import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { getApi } from "../../utils/api";
import { GET_CSAT_STARS_COUNT } from "../../config/Endpoints";
import { getUser } from "../../utils/Storage";

interface CsatStars {
  goldStars: number;
  silverStars: number;
}

export const useCsatStars = (enabled = true): CsatStars => {
  const userData = JSON.parse(getUser("userData"));
  const accessToken = Cookies.get("accessToken");
  const [goldStars, setGoldStars] = useState(0);
  const [silverStars, setSilverStars] = useState(0);

  useEffect(() => {
    if (!enabled || !userData?.id) return;

    const fetchStars = async () => {
      try {
        const res = await getApi(
          `${GET_CSAT_STARS_COUNT}/${userData.id}/count-five-star`,
          accessToken,
        );
        const totalFiveRatings = res?.data?.data?.fiveStarCount || 0;
        setGoldStars(Math.floor(totalFiveRatings / 5));
        setSilverStars(totalFiveRatings % 5);
      } catch {
        // silently fail — stars are non-critical
      }
    };

    fetchStars();
  }, [enabled, userData?.id]);

  return { goldStars, silverStars };
};
